import { computed, effect } from '@preact/signals-core'

import { createAuthRTC } from '$services/rtc/auth'
import { current } from '$store/session'

import { sources as apiSources } from './api'

const sources = computed(() =>
  apiSources.value.map(({ auth: authAPI, id: token_id, user_id }) => ({
    user_id,
    rtc: createAuthRTC({ authAPI, token_id, user_id })
  }))
)

// Cleanup
effect(() => {
  const values = sources.value

  return () => {
    values.forEach(({ rtc: { close } }) => close())
  }
})

const activeSource = computed(() =>
  sources.value.find(({ user_id }) => user_id === current.value)
)

export const rtc = computed(() => activeSource.value?.rtc)
